import React from 'react';

const faqs = [
  {
    question: "What makes a good basketball team name?",
    answer: "A good basketball team name should be memorable, reflect your team's style (streetball, professional, college), and resonate with your players and fans. Consider names that incorporate basketball terminology, local culture, or team values."
  },
  {
    question: "How do you create a unique basketball team name?",
    answer: "To create a unique basketball team name, consider combining elements like your location, team style, and distinctive characteristics. Our generator helps by combining these elements with basketball-specific terms and popular naming patterns."
  },
  {
    question: "What are popular themes for basketball team names?",
    answer: "Popular themes include animals (Hawks, Bulls), weather phenomena (Thunder, Heat), powerful entities (Kings, Warriors), and basketball-specific terms (Dribblers, Ballers). Professional teams often use city names, while streetball teams might use more creative, urban-inspired names."
  },
  {
    question: "Should my basketball team name be serious or fun?",
    answer: "This depends on your team's context. Professional and college teams typically choose more serious names, while recreational and streetball teams often opt for creative or fun names. Consider your audience and the level of competition."
  },
  {
    question: "Can I use my generated team name commercially?",
    answer: "Yes, the names generated are free to use. However, we recommend checking for existing trademarks if you plan to use the name commercially, especially for professional teams."
  },
  {
    question: "How often are new names added to the generator?",
    answer: "Our AI system continuously learns from current basketball trends and user preferences to expand its name generation capabilities, ensuring fresh and relevant suggestions."
  }
];

export default function BasketballFAQ() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Basketball Team Names FAQ
        </h2>
        
        <div className="space-y-8">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-orange-50 p-6 rounded-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {faq.question}
              </h3>
              <p className="text-gray-600">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}